"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const mapToHeaderProps_1 = __importDefault(require("./props/mapToHeaderProps"));
function mapHeader({ header, packages, mappers }) {
    let props = null;
    if (header && typeof header === 'object') {
        props = (0, mapToHeaderProps_1.default)({ data: header, mappers, packages });
    }
    return props && (0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Header, { ...props });
}
exports.default = mapHeader;
